{
  "_vgBinding": "vg-binding: P4.4.2.D-12 P4.4.2.D-13 P4.4.2.D-14 P4.4.2.D-15 INTERFACE-STANDARDS:error-shape — complete vendorAllocations namespace (stats/configs/proposals tabs + dialogs + chip + 9 domain error codes user_message) owned by task-12; Wave-4 tabs consume t() only [task-12]",
  "page": {
    "title": "Vendor Allocations",
    "subtitle": "Thống kê phân bổ đơn theo vendor, cấu hình weight và duyệt đề xuất thay đổi.",
    "newSplit": "+ Tạo split mới"
  },
  "nav": {
    "allocations": "Allocations"
  },
  "tabs": {
    "stats": "Stats",
    "configs": "Configs",
    "proposals": "Proposals"
  },
  "common": {
    "cancel": "Huỷ",
    "close": "Đóng",
    "save": "Lưu",
    "retry": "Thử lại",
    "loading": "Đang tải…",
    "confirm": "Xác nhận",
    "na": "N/A"
  },
  "filters": {
    "searchLabel": "Tìm kiếm",
    "searchPlaceholder": "SKU, blueprint, location…",
    "blueprintLabel": "Blueprint",
    "allBlueprints": "Tất cả blueprint",
    "vendorLabel": "Vendor",
    "allVendors": "Tất cả vendor",
    "statusLabel": "Trạng thái",
    "allStatuses": "Tất cả trạng thái",
    "dateRangeLabel": "Khoảng thời gian"
  },
  "stats": {
    "table": {
      "vendor": "Vendor",
      "variants": "Variant",
      "quantity": "Số lượng",
      "cost": "Chi phí",
      "assignments": "Lượt phân bổ"
    },
    "footer": {
      "totals": "Tổng cộng",
      "missingCostCaveat": "{{count}} lượt phân bổ thiếu chi phí đã chốt"
    },
    "empty": {
      "title": "Chưa có hoạt động phân bổ",
      "description": "Không có lượt phân bổ vendor nào được tạo trong khoảng thời gian này."
    },
    "drilldown": {
      "title": "Chi tiết theo variant",
      "variant": "Variant",
      "sku": "SKU",
      "location": "Location",
      "quantity": "Số lượng",
      "cost": "Chi phí",
      "assignments": "Lượt phân bổ",
      "reconcile": "Tổng đối soát",
      "locationNA": "Location N/A",
      "empty": "Vendor này không có hoạt động variant nào trong khoảng thời gian."
    },
    "assignmentStatus": {
      "rejected": "Đã từ chối",
      "superseded": "Đã thay thế",
      "completed": "Hoàn tất"
    }
  },
  "configs": {
    "table": {
      "blueprint": "Blueprint",
      "variantSku": "Variant (SKU)",
      "location": "Location",
      "vendors": "Vendor",
      "actions": "Thao tác"
    },
    "actions": {
      "disable": "Tắt",
      "propose": "Đề xuất thay đổi",
      "openBlueprint": "Mở blueprint"
    },
    "empty": {
      "title": "Chưa có cấu hình split",
      "description": "Chưa có variant blueprint nào được cấu hình split vendor."
    },
    "pagination": {
      "showing": "Hiển thị {{shown}} / {{total}} cấu hình",
      "prev": "‹ Trước",
      "next": "Sau ›"
    },
    "disable": {
      "title": "Tắt vendor khỏi split",
      "lastVendorWarning": "Đây là vendor cuối cùng còn bật — đơn mới sẽ route theo top-score thay vì split đã cấu hình.",
      "reasonLabel": "Lý do",
      "reasonRequired": "(bắt buộc)",
      "reasonPlaceholder": "Ví dụ: Vendor tạm ngưng nhận đơn mug do hết phôi tuần này…",
      "reasonHint": "Lý do được ghi vào lịch sử allocation để đối soát sau này.",
      "confirm": "Xác nhận tắt",
      "cancel": "Huỷ",
      "toast": {
        "success": "Đã tắt vendor khỏi split."
      }
    },
    "propose": {
      "title": "Đề xuất thay đổi",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Giải thích lý do bật lại hoặc đổi weight…",
      "weightLabel": "Weight (%)",
      "submit": "Gửi đề xuất",
      "toast": {
        "success": "Đã gửi đề xuất chờ duyệt."
      },
      "noChanges": "Không có thay đổi để đề xuất.",
      "disableViaDirect": "Để tắt, dùng dấu ✕ trên thẻ nhà cung cấp (được ghi nhật ký). Đề xuất chỉ có thể bật lại."
    }
  },
  "proposals": {
    "pending": {
      "title": "Hàng chờ duyệt"
    },
    "history": {
      "title": "Lịch sử"
    },
    "table": {
      "blueprint": "Blueprint",
      "variant": "Variant",
      "location": "Location",
      "changes": "Thay đổi",
      "reason": "Lý do",
      "proposedBy": "Người đề xuất",
      "proposedAt": "Thời điểm đề xuất",
      "status": "Trạng thái",
      "decidedBy": "Người xử lý",
      "decidedAt": "Thời điểm xử lý",
      "decisionReason": "Lý do xử lý",
      "actions": "Thao tác"
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối"
    },
    "change": {
      "enable": "Bật",
      "disable": "Tắt",
      "weightDelta": "{{from}}% → {{to}}%",
      "weightSet": "{{to}}%"
    },
    "actions": {
      "approve": "Duyệt",
      "reject": "Từ chối"
    },
    "selfApprovalDisabled": "Không thể tự duyệt đề xuất của mình.",
    "empty": {
      "pending": "Không có đề xuất nào đang chờ duyệt.",
      "history": "Chưa có đề xuất nào được xử lý."
    },
    "badge": {
      "pendingAria": "{{count}} đề xuất đang chờ duyệt"
    },
    "reject": {
      "title": "Từ chối đề xuất",
      "reasonLabel": "Lý do",
      "reasonRequired": "(bắt buộc)",
      "reasonPlaceholder": "Giải thích lý do từ chối đề xuất này…",
      "confirm": "Xác nhận từ chối",
      "cancel": "Huỷ",
      "toast": {
        "success": "Đã từ chối đề xuất."
      }
    },
    "approve": {
      "confirmTitle": "Duyệt đề xuất",
      "toast": {
        "success": "Đã duyệt và áp dụng đề xuất."
      }
    }
  },
  "chip": {
    "enabled": "Enabled",
    "disabled": "Disabled",
    "weightAria": "Weight {{pct}}%",
    "inactive": "đang bị treo",
    "missing": "không có hồ sơ"
  },
  "errors": {
    "ALLOC_SUM_INVALID": "Tổng weight các vendor phải bằng 100%.",
    "ALLOC_RANGE_TOO_WIDE": "Khoảng thời gian phải từ 365 ngày trở xuống.",
    "ALLOC_RANGE_INVALID": "Ngày bắt đầu phải trước ngày kết thúc.",
    "ALLOC_ENTRY_NOT_FOUND": "Không tìm thấy cấu hình allocation.",
    "ALLOC_ALREADY_DISABLED": "Vendor này đã bị tắt trong split này.",
    "ALLOC_PATCH_FORBIDDEN": "Sửa weight của split đã có phải qua đề xuất duyệt.",
    "PROPOSAL_SELF_APPROVAL": "Bạn không thể tự duyệt đề xuất của mình.",
    "PROPOSAL_STALE": "Blueprint đã thay đổi kể từ đề xuất này — vui lòng tạo lại đề xuất.",
    "PROPOSAL_PENDING_EXISTS": "Đã có một đề xuất đang chờ duyệt cho split này.",
    "PROPOSAL_ALREADY_DECIDED": "Đề xuất này đã được xử lý.",
    "PROPOSAL_DISABLE_FORBIDDEN": "Để tắt một nhà cung cấp, hãy dùng thao tác tắt trực tiếp để được ghi nhật ký kiểm toán — không thể đề xuất qua phê duyệt.",
    "ALLOCATION_VENDOR_NOT_IN_LOCATION_BINDING": "Phần chia này giao việc cho vendor mà ràng buộc location không bao gồm. Chưa lưu gì cả — sửa lại phần chia, hoặc mở rộng ràng buộc trước.",
    "locationBinding": {
      "list": "Ràng buộc không bao gồm: {{list}}.",
      "more": "Và {{count}} trường hợp nữa."
    },
    "VALIDATION_FAILED": "Một số trường không hợp lệ. Vui lòng kiểm tra lại.",
    "UNAUTHENTICATED": "Vui lòng đăng nhập để tiếp tục.",
    "FORBIDDEN": "Bạn không có quyền thực hiện thao tác này.",
    "PROPOSAL_NOT_FOUND": "Không tìm thấy đề xuất.",
    "NETWORK_ERROR": "Lỗi mạng — vui lòng kiểm tra kết nối.",
    "GENERIC": "Đã có lỗi xảy ra. Vui lòng thử lại.",
    "AUTH_CSRF_MISSING": "Thiếu mã bảo mật phiên. Vui lòng tải lại trang và thử lại.",
    "AUTH_CSRF_MISMATCH": "Mã bảo mật phiên đã hết hạn. Vui lòng tải lại trang và thử lại.",
    "TIMEOUT": "Yêu cầu quá thời gian chờ. Vui lòng thử lại.",
    "INTERNAL_ERROR": "Đã xảy ra lỗi từ phía hệ thống. Vui lòng thử lại."
  }
}
